import React from 'react';
import '../Languages.css'; // Import the CSS file

function Languages({ id }) {
  return (
    <section id={id}>
      <h2>Languages</h2>
      <div className="languages-container">
        <div className="language-item">
          <h3>Spanish</h3>
          <p>Native</p>
        </div>
        <div className="language-item">
          <h3>Galician</h3>
          <p>Native</p>
        </div>
        <div className="language-item">
          <h3>English</h3>
          <p>Professional competence</p>
        </div>
      </div>
    </section>
  );
}

export default Languages;
